import api from '@/shared/api';

export type RecordLinkContainerType = 'folder' | 'module';

export interface RecordLinkContainer {
  type: RecordLinkContainerType;
  id: number;
}

interface LinkMatricesToContainerResponse {
  linkedCount: number;
}

function buildMatricesUrl(container: RecordLinkContainer): string {
  return container.type === 'module'
    ? `/modules/${container.id}/matrices`
    : `/folders/${container.id}/matrices`;
}

export async function linkMatricesToContainer(
  container: RecordLinkContainer,
  matrixIds: number[]
): Promise<number> {
  const response = await api.post<{ data: LinkMatricesToContainerResponse }>(
    buildMatricesUrl(container),
    { matrixIds }
  );

  return response.data.data.linkedCount;
}
